import getIn from 'lodash/get';
import noop from 'lodash/noop';
import UAParser from 'ua-parser-js';

import { type State } from 'src/types';

import { CapabilitiesStateKeys } from '../constants/Capabilities';

export function isMobileWeb(state: State): boolean {
  return state.capabilities.get(CapabilitiesStateKeys.IS_MOBILE);
}

export function isTablet(state: State): boolean {
  return state.capabilities.get(CapabilitiesStateKeys.IS_TABLET);
}

export function isMobileDevice(state: State): boolean {
  return isMobileWeb(state) || isTablet(state);
}

export function isBrowseMobileEnabled(state: State): boolean {
  return isMobileDevice(state);
}

export function isPlaybackEnabled(state: State): boolean {
  return !isMobileWeb(state);
}

export function isTopNavEnabled(state: State): boolean {
  return !isMobileWeb(state);
}

export function showLogoOnlyHeader(state: State): boolean {
  return isMobileWeb(state);
}

export function shouldRenderBSPSidebarButtons(state: State): boolean {
  return !isMobileWeb(state);
}

export function disableHoverStates(state: State): boolean {
  return isMobileWeb(state);
}

export function isAndroidDevice(): boolean {
  const UserAgent = new UAParser();
  if (UserAgent?.getOS().name) {
    return !!UserAgent?.getOS()?.name?.match(/Android/);
  }
  return false;
}

export function isIEorEdge(): boolean {
  const BrowserAgent = new UAParser().getBrowser().name;
  return BrowserAgent === 'IE' || BrowserAgent === 'Edge';
}

export function isIE11(): boolean {
  const browser = new UAParser().getBrowser();
  return browser.name === 'IE' && !!browser?.version?.startsWith('11');
}

export function isIE(): boolean {
  const browser = new UAParser().getBrowser();
  return browser.name === 'IE';
}

export function isOldAndroid(): boolean {
  const UserVersion = new UAParser().getOS().version;
  return isAndroidDevice() && (UserVersion === '6.0.1' || UserVersion === '6.0');
}

export function isAutoStartEnabled(): boolean {
  // 1. Disable auto-start if on desktop app
  // 2. Enable auto-start if the app is launched via Windows pinned-station tile (ignore #1)
  const isLaunchedViaStationTile = getIn(window, 'DesktopBridge.isLaunchedViaStationTile', noop)();
  return !window.isElectron() || isLaunchedViaStationTile;
}
